export default "static/media/loblaw-digital.eb96209.svg"